import { useSelector } from 'react-redux';
import { defaultColor, type Stroke } from '@bynder-studio/misc';
import { getSplitFeatures } from 'packages/store/user/user.selectors';
import { ActiveSplits } from 'packages/store/user/types';

export const useIsOutlineColorEnabled = () =>
    useSelector(getSplitFeatures)?.[ActiveSplits.studioTextOutlineColor] === 'on';

export const useOutlineSettingDefaults = (stroke: Stroke): Partial<Stroke> => {
    const isOutlineColorEnabled = useIsOutlineColorEnabled();

    return isOutlineColorEnabled
        ? { strokeColor: stroke.strokeColor ?? defaultColor, punchOut: stroke.punchOut ?? false }
        : {};
};

export default useIsOutlineColorEnabled;
